function redirectUponSignIn() {
    // Redirect to home page upon sign in unless there is a nextPage search param
    const pathname = window.location.pathname.toLowerCase();
    const nextPageString = 'nextPage=';
    const nextPageIndex = window.location.search.indexOf(nextPageString);
    if (window.location.search.includes(nextPageString)) {
        const nextPage = window.location.search.substr(
            nextPageIndex + nextPageString.length,
        );
        window.location.assign(nextPage);
    } else if (pathname === '/signin' || pathname === '/signin/') {
        window.location.assign('/');
    }
}

export {
    redirectUponSignIn,
};
